import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'
import Modal from '@mui/material/Modal'
import React, { useEffect, useState } from 'react'
import CompareModal from 'src/components/BuyPolicy/modals/CompareModal'
import { useSelector } from 'react-redux'
import { addScroll, removeScroll } from 'src/utils/commonMethods'

const ComparePolicies = () => {
  const classes = useStyles()
  const [modalOpen, setModalOpen] = useState(false)
  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)
  const compareList = guestUserDetails?.comparePlanList

  useEffect(() => {
    if (modalOpen) {
      removeScroll()
    } else {
      addScroll()
    }
  }, [modalOpen])
  const closeModal = () => {
    setModalOpen(false)
  }
  return (
    <>
      {modalOpen ? (
        <Modal id='modal' open={modalOpen} onClose={closeModal}>
          <div className={'modal-container'}>
            <CompareModal compareList={compareList} closeModal={closeModal} />
          </div>
        </Modal>
      ) : null}

      {compareList?.length >= 2 ? (
        <div
          id='compareContainer'
          className={classes.container}
          onClick={() => setModalOpen(true)}
        >
          Compare: {compareList?.length}
        </div>
      ) : null}
    </>
  )
}

export default ComparePolicies

export const useStyles = makeStyles({
  container: {
    background: 'linear-gradient(82.69deg, #19ADD6 24.68%, #4DC3E3 102.81%)',
    boxShadow: '0px 4px 10px 0px #C3C3C3',
    color: COLORS.WHITE,
    borderRadius: '10px',
    height: '50px',
    width: '250px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    position: 'fixed',
    right: '50px',
    bottom: '-100%',
    opacity: 0,
    zIndex: '10',
    animation: '$smoothAppear 1s ease forwards',
  },
  '@keyframes smoothAppear': {
    to: {
      bottom: '10%',
      opacity: 1,
    },
  },
})
